<template>
  <div v-if="props.entity.creator" class="create-update-wrapper card-title font-weight-normal mb-0">
    <span class="create-update-title">{{ t('common.creationDate') }}</span>
    {{
      t('common.creationDateContent', [
        computeCreateUpdateDate(props.entity.created_at),
        capitalizeFirstLetter(props.entity.creator.first_name),
        capitalizeFirstLetter(props.entity.creator.last_name),
      ])
    }}
  </div>

  <div v-if="props.entity.updater" class="create-update-wrapper card-title font-weight-normal mb-0">
    <span class="create-update-title">{{ t('common.lastUpdate') }}</span>
    {{
      t('common.lastUpdateContent', [
        computeCreateUpdateDate(props.entity.updated_at),
        computeCreateUpdateTime(props.entity.updated_at),
        capitalizeFirstLetter(props.entity.updater.first_name),
        capitalizeFirstLetter(props.entity.updater.last_name),
      ])
    }}
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { dateToDayMonthYearString, dateToHourMin } from '@common/filters/date-formatter';

const { t } = useI18n({ useScope: 'global' });

const props = defineProps(['entity']);

const capitalizeFirstLetter = value => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const computeCreateUpdateDate = date => {
  return date ? dateToDayMonthYearString(new Date(date)) : '-';
};

const computeCreateUpdateTime = date => {
  return date ? dateToHourMin(new Date(date)) : '-';
};
</script>

<style lang="scss" scoped>
@import '@styles/variables.scss';
.create-update-wrapper {
  color: $gray-500;
  font-size: $font-size-base;
  .create-update-title {
    text-decoration: underline;
  }
}
</style>
